// extracted by mini-css-extract-plugin
export default {"head":"TableProductsHead_head__5jazY","headColumn":"TableProductsHead_headColumn__7Qk9x","sortButtonContainer":"TableProductsHead_sortButtonContainer__2Sj2m"};